import { useState, useEffect } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import pPipe from 'src/utils/pPipe';
import Content from 'src/componentes/pages/content';
import http from 'src/services/httpService';

import PontoControleView from './view';

function PontoControleList({ resources, intl, ...rest }) {
  const [configuracao, setConfig] = useState(null);

  const [idFiltroSalvo, setIdFiltroSalvo] = useState(0);
  const [ehFavorito, setEhFavorito] = useState(false);
  const [tipoFiltro, setTipoFiltro] = useState(null);

  const getFiltroFavorito = (id, ehFavorito, tipoFiltro) => {
    setIdFiltroSalvo(id);
    setEhFavorito(ehFavorito);
    setTipoFiltro(tipoFiltro);
  };

  const obterConfiguracao = async () =>
    await pPipe(
      async () =>
        await http.post(`/PontoControleConfiguracao/ObterConfiguracoes`),
      ({ data: { model } }) => model,
      setConfig
    )();

  useEffect(() => {
    obterConfiguracao();
  }, []);

  if (!configuracao) return null;

  return (
    <Content
      data-testid="gerenciar-ponto-controle-page"
      titulo={intl.formatMessage(
        { id: 'pontosDeControlesCadastrados' },
        { pontosdecontrole: resources.pontosdecontrole }
      )}
      iconSettings={true}
      urlSettings="/configuracoes/ponto-controle"
      endPointPermissionSettings="/PontoControleConfiguracao/PossuiPermissaoConfiguracao"
      iconFavorite={true}
      filtroFavorito={{
        id: idFiltroSalvo,
        ehFavorito: ehFavorito,
        tipoFiltro: tipoFiltro,
      }}
    >
      <PontoControleView
        {...{ ...rest, configuracao }}
        urlController={'/PontoControle'}
        getFiltroFavorito={getFiltroFavorito}
      />
    </Content>
  );
}

function mapStateToProps(state) {
  return {
    resources: state.user.termos,
  };
}

export default injectIntl(connect(mapStateToProps)(PontoControleList));
